import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "../theme/theme";

/**
 * One labelled group of fields inside the object/client dialogs.
 *
 * The add and edit forms carry fourteen fields each. As one uninterrupted
 * column they were a scroll with no landmarks; grouped under headings a realtor
 * can jump straight to the part they came to change. Add and Edit share this so
 * the two forms cannot drift apart.
 */
export default function FormSection({ title, icon, children, sx }) {
  return (
    <Box sx={{ mb: 2.75, ...sx }}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ mb: 1.75, color: tokens.ink500 }}
      >
        {icon}
        <Typography
          variant="overline"
          sx={{ fontWeight: 700, letterSpacing: "0.09em", lineHeight: 1 }}
        >
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1, height: "1px", backgroundColor: tokens.line }} />
      </Stack>
      {children}
    </Box>
  );
}
